// export default BulkPublic;
import React, { useState, useEffect, useMemo } from "react";
import {
  Typography,
  MenuItem,
  Grid,
  Button,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import data from "../../Component/dropDown";
import { API } from "../backend";
import { useDispatch, useSelector } from "react-redux";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import InputField from "../../Component/forms/input/TextInput/InputField";
import { examPrices } from "../../partials/examboardprices/examprices";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FormButton from "../../Component/ui/button/FormButton";
import axios from "axios";
import { closeModal } from "../../store/reducers/modal";
import InvoiceButtonWithConfirmation from "../../Component/InvoiceButtonWithConfirmation";
const BulkTrade = ({
  dat,
  examName,
  examType = "PUBLIC SERVICE EXAMINATION",
  lateRegistrationType = "Model/Screening College Late Registration",
  payerID,
}) => {
  const { LgaForPublic } = data;
  console.log(dat)

  const token = useSelector((state) => state.user.data.token);
  // const details = useSelector((state) => state.transactionDetails);
  const user = useSelector((state) => state.user.data.details);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [publicBulkData, setPublicBulkData] = useState([]);

  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const { Lga } = data;
  const [formData, setFormData] = useState([
    {
      // Personal Details
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      examNumber: "",
      phoneNumber: "",
      stateOfOrigin: "",
      localGovernment: "",
      address: "",
      nin: "",
      lassra: "",

      // Trade Test Information
      typeOfTradeTest: "",
      paymentReceiptNumber: "",
      yearOfExamination: "",

      // Professional Information (For Civil Servants Only)
      qualification: "",
      qualificationDate: "",
      firstAppointmentDate: "",
      presentAppointmentDate: "",
      designation: "",
      oracleNumber: "",
      mda: "",

      // Examination Information
      examinationCenter: "",
      examinationDate: "",
    },
  ]);

  const handlInputChange = (e) => {
    const { name, value, type } = e.target;

    // For select fields (like LGA), don't trim the value
    const shouldTrim = type !== "select-one";

    setFormData({
      ...formData,
      [name]: shouldTrim ? value?.trim() : value,
    });
  };

  //   const [candidates, setCandidates] = useState([
  //     { lastName: "", middleName: "", firstName: "", lga: "" },
  //   ]);

  //   console.log(candidates.length);
  //   const candidateInfo = candidates.map((candidate, index) => ({
  //     surname: candidate.lastName,
  //     middleName: candidate.middleName,
  //     firstName: candidate.firstName,
  //     //  lgaIdNumber: candidate.lga,
  //     locationIdOrExamId: candidate.lga,
  //   }));

  // console.log(candidateInfo)

  const addCandidate = () => {
    const newCandidate = {
      // Personal Details
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      examNumber: "",
      phoneNumber: "",
      stateOfOrigin: "",
      localGovernment: "",
      address: "",
      nin: "",
      lassra: "",

      // Trade Test Information
      typeOfTradeTest: "",
      paymentReceiptNumber: "",
      yearOfExamination: "",

      // Professional Information
      qualification: "",
      qualificationDate: "",
      firstAppointmentDate: "",
      presentAppointmentDate: "",
      designation: "",
      oracleNumber: "",
      mda: "",

      // Examination Information
      examinationCenter: "",
      examinationDate: "",
    };

    setFormData([...formData, newCandidate]);

  };
  const removeCandidate = (index) => {
    if (formData.length > 1) {
      setFormData(formData.filter((_, i) => i !== index));
    }
  };
      const handleCandidateChange = (index, field, value) => {
      const updatedCandidates = [...formData];
      updatedCandidates[index][field] = value;
      setFormData(updatedCandidates);
    };

  //   const removeCandidate = (index) => {
  //     const updateCandidate = candidates.filter((_, idx) => idx !== index);
  //     setCandidates(updateCandidate);
  //   };

  //   const handleCandidateChange = (index, field, value) => {
  //     const updatedCandidates = [...candidates];
  //     updatedCandidates[index] = { ...updatedCandidates[index], [field]: value };
  //     setCandidates(updatedCandidates);
  //   };

  const priceInt = examPrices.publicServiceExamCompulsory.replace(/\D/g, "");
  const totalFee = priceInt * formData.length;

  // const totalAmount = parseInt(charge) + parseInt(totalFee);

  const charge = useMemo(() => {
    let ch = 0.01 * totalFee;
    if (ch > 3000) return 3000;
    return ch;
  }, [totalFee]);

  const totalAmount = parseInt(charge) + parseInt(totalFee);

  // console.log(user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
    } catch (error) {}
  };

  const getPublicExam = async () => {
    const examBillable_url = `${API}/cbs/public_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setPublicBulkData(res?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const generateBillNo = async () => {
    // Start the timeout
    let timeoutId = setTimeout(() => {
      setShowTimeoutModal(true);
    }, 120000); // 2 minutes in milliseconds

    const body = {
      payer_id: payerID,
      customer_name: `${user.lastName} ${user.firstName}`,
      selected_quantities: [parseInt(formData.length)],
      selected_items: [publicBulkData?.[0]?.PRODUCTS_ID],
      selected_tariffs: [10000],
      assessmentCode: "02",
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // If the request completes successfully, clear the timeout
      clearTimeout(timeoutId);
      // console.log(res)
      if (res?.status === 200) {
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.bill_number);

        const billdata = {
          // schoolId: '',
          billNumber: res?.data?.data?.bill_number,
          // payerId: details?.payerId,
          payerId: payerID,
          amountGenerated: totalFee,
          customerName: `${user.lastName} ${user.firstName}`,
          quantity: formData.length,
          assessmentCode: "02",
          //   payerInfos: candidateInfo,
        };

        saveGeneratedBill(billdata);
        // console.log(bill);

        // console.log(bill);
        // transactionDetails.billNumber = res?.data?.data?.responseData;
        // console.log(transactionDetails);
        const modelUserTransactionDetails = {
          payerName: ` ${user.lastName} ${user.firstName} `,
          productQuantity: parseInt(formData.length),
          price: totalFee,
          // schoolName: "",
          unitPrice: parseInt(priceInt),
          examType,
          paymentExamType: examType,
          fullDesc: "Public Service Examination",
          billNumber: res?.data?.data?.bill_number,
          payerId: user?.payerId,
          address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        // console.log(modelUserTransactionDetails);

        // console.log("i got here");
        dispatch(setTransactionDetails(modelUserTransactionDetails));
        // dispatch(setTransactionDetails(userTransactionDetails));
        dispatch(closeModal({ content: <></> }));
        navigate("/invoice");

        // console.log(modelUserTransactionDetails);
        // console.log(details);

        // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
        // console.log(details)
        // navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
      // If the request completes successfully, clear the timeout
      clearTimeout(timeoutId);
      if (axios.isAxiosError(error)) {
        const backendMessage =
          error.response?.data?.message || "Something went wrong";
        toast.error(backendMessage);
      } else {
        toast.error("Unable to generate invoice, please try again later.");
      }

      // console.log(error);
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);
    try {
      // e.preventDefault();
      const isEmpty = formData.some((candidate) => {
        if (
          candidate.firstName.trim().length < 3 ||
          candidate.lastName.trim().length < 3
        ) {
          throw new Error(
            "First Name and Last Name are required with a minimum of 3 characters."
          );
        }

        if (!candidate.lga) {
          throw new Error("PSE type is required.");
          // throw new Error("Local Government Area is required.");
        }

        return false;
      });

      if (isEmpty) {
        // No need to throw an error here since all validations are handled within the `isEmpty` check
      }

      await generateBillNo();
      // console.log(transactionDetails)
      // console.log(examName)
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
    } finally {
      setInvoiceLoading(false);
    }
  };

  useEffect(() => {
    getPublicExam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        padding: "16px",
        maxHeight: "calc(100vh - 160px)",
        overflowY: "auto",
      }}
    >
      {formData.map((candidate, index) => (
        <div
          key={index}
          style={{
            // display: "flex",
            // alignItems: "center",
            // gap: "1.5rem",
            padding: "16px",
          }}
        >
          <div>
            <Typography variant="h6" style={{ marginBottom: 20 }}>
      Candidate #{index + 1}
      {index > 0 && (
        <Button 
          variant="outlined" 
          color="error" 
          onClick={() => removeCandidate(index)}
          style={{ marginLeft: 20 }}
        >
          Remove
        </Button>
      )}
    </Typography>
            {/* Personal Details Section */}
            <Typography
              variant="h6"
              gutterBottom
              style={{ marginTop: "20px", font: "bolder" }}
            >
              Personal Details
            </Typography>

            {/* Name Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <InputField
                  name="firstName"
                  label="First Name"
                  value={candidate.firstName}
                  onChange={(e) => handleCandidateChange(index, 'firstName', e.target.value)}

                  placeholder="Enter First Name"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <InputField
                  name="middleName"
                  label="Middle Name"
                  value={candidate.middleName}
                  onChange={(e) => handleCandidateChange(index, 'middleName', e.target.value)}

                  placeholder="Enter Middle Name"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <InputField
                  name="lastName"
                  label="Surname"
                  type="text"
                  placeholder="Enter Surname"
                  value={candidate.lastName}
                  onChange={(e) => handleCandidateChange(index, 'lastName', e.target.value)}

                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Date of Birth and Exam Number Row */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="dateOfBirth"
                  label="Date of Birth"
                  type="date"
                  value={candidate.dateOfBirth}
                  onChange={(e) => handleCandidateChange(index, 'dateOfBirth', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="examNumber"
                  label="Exam Number"
                  value={candidate.examNumber}
                  onChange={(e) => handleCandidateChange(index, 'examNumber', e.target.value)}

                  placeholder="Enter Exam Number"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Phone Number and State of Origin Row */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="phoneNumber"
                  label="Phone Number"
                  value={candidate.phoneNumber}
                  onChange={(e) => handleCandidateChange(index, 'phoneNumber', e.target.value)}

                  placeholder="Enter Phone Number"
                  type="tel"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="stateOfOrigin"
                  label="State of Origin"
                  value={candidate.stateOfOrigin}
                  onChange={(e) => handleCandidateChange(index, 'stateOfOrigin', e.target.value)}

                  placeholder="Enter State of Origin"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Local Govt and Address Row */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12} sm={6} md={6}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#9b9494",
                    fontSize: "1rem",
                    fontWeight: "bolder",
                    marginTop: "7px",
                  }}
                  mb={1}
                >
                  LGA
                </Typography>
                <FormControl fullWidth>
                  <InputLabel id="lga-select-label">
                    Local Government Area (LGA)
                  </InputLabel>
                  <Select
                    labelId="lga-select-label"
                    id="lga-select"
                    value={candidate.localGovernment}
                    onChange={(e) => handleCandidateChange(index, 'localGovernment', e.target.value)}

                    label="Local Government Area (LGA)"
                    name="localGovernment"
                  >
                    {Lga.map((lgaItem) => (
                      <MenuItem key={lgaItem.lgaId} value={lgaItem.lgaId}>
                        {lgaItem.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="address"
                  label="Address"
                  value={candidate.address}
                  onChange={(e) => handleCandidateChange(index, 'address', e.target.value)}

                  placeholder="Enter Full Address"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* NIN and LASSRA Row */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="nin"
                  label="National Identification Number (NIN)"
                  value={candidate.nin}
                  onChange={(e) => handleCandidateChange(index, 'nin', e.target.value)}

                  placeholder="Enter NIN"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="lassra"
                  label="LASSRA Number"
                  value={candidate.lassra}
                  onChange={(e) => handleCandidateChange(index, 'lassra', e.target.value)}

                  placeholder="Enter LASSRA Number"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ marginTop: "30px" }}>
            {/* Trade Test Information Section */}
            <Typography variant="h6" gutterBottom>
              TRADE TEST INFORMATION
            </Typography>

            {/* Type of Trade Test Row - Single field spanning full width */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InputField
                  name="typeOfTradeTest"
                  label="Type of Trade Test"
                  value={candidate.typeOfTradeTest}
                  onChange={(e) => handleCandidateChange(index, 'typeOfTradeTest', e.target.value)}

                  placeholder="Enter Type of Trade Test"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Payment Receipt Number Row - Single field spanning full width */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12}>
                <InputField
                  name="paymentReceiptNumber"
                  label="Payment Receipt Number"
                  value={candidate.paymentReceiptNumber}
                  onChange={(e) => handleCandidateChange(index, 'paymentReceiptNumber', e.target.value)}

                  placeholder="Enter Payment Receipt Number"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Year of Examination Row - Single field spanning full width */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12}>
                <InputField
                  name="yearOfExamination"
                  label="Year of Examination"
                  value={candidate.yearOfExamination}
                  onChange={(e) => handleCandidateChange(index, 'yearOfExamination', e.target.value)}

                  placeholder="Enter Year of Examination"
                  type="number"
                  inputProps={{ min: "2000", max: "2099" }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ marginTop: "30px" }}>
            {/* Professional Information Section */}
            <Typography variant="h6" gutterBottom>
              PROFESSIONAL INFORMATION (FOR CIVIL SERVANTS ONLY)
            </Typography>

            {/* Qualification and Qualification Date Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="qualification"
                  label="Qualification"
                  value={candidate.qualification}
                  onChange={(e) => handleCandidateChange(index, 'qualification', e.target.value)}

                  placeholder="Enter Qualification"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="qualificationDate"
                  label="Qualification Date"
                  type="date"
                  value={candidate.qualificationDate}
                  onChange={(e) => handleCandidateChange(index, 'qualificationDate', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Date of First Appointment and Present Appointment Row */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="firstAppointmentDate"
                  label="Date of First Appointment"
                  type="date"
                  value={candidate.firstAppointmentDate}
                  onChange={(e) => handleCandidateChange(index, 'firstAppointmentDate', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="presentAppointmentDate"
                  label="Date of Present Appointment"
                  type="date"
                  value={candidate.presentAppointmentDate}
                  onChange={(e) => handleCandidateChange(index, 'presentAppointmentDate', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* Designation/Grade Level and Oracle Number Row */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="designation"
                  label="Designation/Grade Level"
                  value={candidate.designation}
                  onChange={(e) => handleCandidateChange(index, 'designation', e.target.value)}

                  placeholder="Enter Designation/Grade Level"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputField
                  name="oracleNumber"
                  label="Oracle Number"
                  value={candidate.oracleNumber}
                  onChange={(e) => handleCandidateChange(index, 'oracleNumber', e.target.value)}

                  placeholder="Enter Oracle Number"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>

            {/* MDA (Ministry/Department/Agency) Row - Full width */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12}>
                <InputField
                  name="mda"
                  label="MDA (Ministry/Department/Agency)"
                  value={candidate.mda}
                  onChange={(e) => handleCandidateChange(index, 'mda', e.target.value)}

                  placeholder="Enter MDA"
                  type="text"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ marginTop: "30px" }}>
            {/* Examination Information Section */}
            <Typography variant="h6" gutterBottom>
              EXAMINATION INFORMATION
            </Typography>

            {/* Examination Center Row - Full width */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Examination Center</InputLabel>
                  <Select
                    name="examinationCenter"
                    value={candidate.examinationCenter}
                    onChange={(e) => handleCandidateChange(index, 'examinationCenter', e.target.value)}

                    label="Examination Center"
                  >
                    <MenuItem value="Lagos">Lagos</MenuItem>
                    <MenuItem value="Abuja">Abuja</MenuItem>
                    <MenuItem value="Kano">Kano</MenuItem>
                    <MenuItem value="Port Harcourt">Port Harcourt</MenuItem>
                    <MenuItem value="Enugu">Enugu</MenuItem>
                    {/* Add more centers as needed */}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Examination Date Row - Full width */}
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid item xs={12}>
                <InputField
                  name="examinationDate"
                  label="Examination Date"
                  type="date"
                  value={candidate.examinationDate}
                  onChange={(e) => handleCandidateChange(index, 'examinationDate', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      ))}
      <div
        style={{
          padding: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
          container
        >
          <Grid item xs={2}>
            <FormButton
              width="medium"
              label="Add Candidate"
              onClick={addCandidate}
            />
          </Grid>
          <Grid item xs={2}>
            <InvoiceButtonWithConfirmation
              invoiceLoading={invoiceLoading}
              handleInvoiceClick={handleInvoiceClick}
            />
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default BulkTrade;
